/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import overviewAPI from 'src/api/overview';

export const getUpcomingCalls = createAsyncThunk('upcomingCalls/get', async arg => {
  return overviewAPI.getUpcomingCalls(arg);
});

const Slice = createSlice({
  name: 'upcomingCalls',
  initialState: {
    isTabExpended: true,
    message: '',
    data: [],
    arg: false,
  },
  reducers: {
    setTabExpend: (state, action) => {
      state.isTabExpended = action.payload;
    },
  },
  extraReducers: {
    [getUpcomingCalls.pending]: (state, action) => {
      state.status = 'loading';
      state.arg = action.meta.arg;
    },
    [getUpcomingCalls.fulfilled]: (state, action) => {
      const { status, message, data } = action.payload;
      state.status = status;
      state.message = message;
      state.data = data;
    },
    [getUpcomingCalls.rejected]: () => {},
  },
});

export const { setTabExpend } = Slice.actions;
export default Slice.reducer;
